// extracted by mini-css-extract-plugin
export var bodySections = "_9w-8";
export var gray = "_9w-7";
export var green = "_9w-4";
export var iconContainer = "_9w-9";
export var iconWidgetContainer = "_9w-1";
export var phoneIcon = "_9w-2";
export var red = "_9w-5";
export var statusDot = "_9w-3";
export var widgetContainer = "_9w-0";
export var yellow = "_9w-6";